import React from 'react';
import HeroSection from '../components/Sections/HeroSection';
import WelcomeSection from '../components/Sections/WelcomeSection';
import GallerySection from '../components/Sections/GallerySection';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <WelcomeSection />
      <GallerySection />
      
      {/* Additional sections can be added here */}
      <section className="section bg-gradient-to-b from-ocean-50 to-white">
        <div className="text-center">
          <h2 className="section-header">Our Services</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Service Cards */}
            {[
              {
                title: "Ship Charter",
                icon: "🚢",
                description: "Large ship charter services for international cargo transport"
              },
              {
                title: "Fleet Rental",
                icon: "⚓",
                description: "Comprehensive ship rental solutions for maritime operations"
              },
              {
                title: "Ocean Transport",
                icon: "🌊",
                description: "Reliable ocean transportation services in Egypt"
              },
              {
                title: "Cargo Solutions",
                icon: "📦",
                description: "Specialized cargo handling and shipping logistics"
              }
            ].map((service, index) => (
              <div key={index} className="maritime-card p-6 text-center slide-up">
                <div className="text-4xl mb-4">{service.icon}</div>
                <h3 className="text-lg font-bold text-deep-800 mb-3">{service.title}</h3>
                <p className="text-gray-600 text-sm">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;